module.exports = __webpack_public_path__ + "static/media/83ecf4b9dd78296d21745e5a4edc4856.27e11520.jpg";